import React from "react";
import { SectionHeading } from "../UI/Card";

const POINTS = [
  {
    icon: "fa-tags",
    title: "Best Price Guarantee",
    desc: "Compare fares across airlines, hotels & bus operators to get the lowest price, every time.",
  },
  {
    icon: "fa-bolt",
    title: "Instant Confirmation",
    desc: "Get your tickets and booking confirmation instantly — no waiting, no hassle.",
  },
  {
    icon: "fa-shield-halved",
    title: "Secure Payments",
    desc: "Bank-grade encrypted payments via Razorpay — your money and data stay safe.",
  },
  {
    icon: "fa-headset",
    title: "24/7 Support",
    desc: "Our support team is available round the clock for any booking assistance.",
  },
];

export default function WhyRasutrip() {
  return (
    <section className="max-w-[1280px] mx-auto px-5 sm:px-6 py-14">
      <SectionHeading eyebrow="Why Bachatwali Ticket" title="Built for a smoother journey" className="mb-8" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {POINTS.map((p) => (
          <div key={p.title} className="rounded-2xl border border-ink-100 p-5 sm:p-6 hover:border-brand-200 hover:bg-brand-50/40 transition">
            <div className="h-11 w-11 rounded-xl bg-brand-50 text-brand-600 flex items-center justify-center mb-4">
              <i className={`fa-solid ${p.icon}`} />
            </div>
            <h3 className="font-bold text-ink-900 text-[15px] mb-1.5">{p.title}</h3>
            <p className="text-sm text-ink-500 leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
